import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SharedService {
  private dataSubject = new BehaviorSubject<string>(''); 
  // Set the initial value
  setData(data: string) {
    this.dataSubject.next(data);
  }
  getData() {
    return this.dataSubject.asObservable();
  }
}